import { Breadcrumb, Button, Col, Form, Image, Row, Steps, Tooltip } from "antd";
import CWLayout from "../cwLayout";
import "./cwSwapDocument.scss";
import { _adr } from "../../../../address";
import { DeleteOutlined, EditOutlined, HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import {
	ExportDocument,
	delay,
	exportNormalFile,
	fileToBase64,
	fileToformData,
	getFieldDocument,
	regexFormater,
	urltoFile,
	validateInput,
} from "../../../../tools/tools";
import { useState } from "react";
import UploadImages from "../../../auxiliary/uploadImages/upload";
import { useDispatch, useSelector } from "react-redux";
import { Value } from "sass";
import Loading from "../../../auxiliary/loader/loading";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import { useNavigate } from "react-router-dom";
import { simcardPurchase } from "../../../../reducer/serviceReducer";
import ResizeImage from "../../../auxiliary/resizeImg/resizeImage";
const CWSwapDocument = () => {
	const [t] = useTranslation("global");
	const [frmDocument] = Form.useForm();

	const [isLoading, setIsLoading] = useState(false);
	const formData = useSelector((state) => state?.from?.changeownership);
	const dispatch = useDispatch();
	const nav = useNavigate();

	const { addDocument } = useAPIPublic();
	const { addProfile, addAddress, updateDocumentProfile } = useDealer();

	const handleSubmit = async (values) => {
		try {
			setIsLoading(true);

			//add cert seller
			let resSellerDocument = await addDocument(await fileToformData(values.documentSeller), getFieldDocument(formData?.seller?.documenttype));
			if (resSellerDocument) {
				const payloadSellerUpdate = {
					sppurchaseid: formData?.seller?.purchaseProductId,
					documentid: resSellerDocument.Result,
				};
				const responseUpdateProfileSeller = await updateDocumentProfile(payloadSellerUpdate);
				if (responseUpdateProfileSeller) {
					let resBuyerDocument = await addDocument(await fileToformData(values.documentBuyer), getFieldDocument(formData?.buyer?.profile?.certtype));
					if (resBuyerDocument) {
						let payload = {
							fname: formData?.buyer?.profile?.isLangPersian ? formData?.buyer?.profile?.fname : undefined,
							lname: formData?.buyer?.profile?.isLangPersian ? formData?.buyer?.profile?.lname : undefined,
							fathername: formData?.buyer?.profile?.isLangPersian ? formData?.buyer?.profile?.fathername : undefined,
							identityno: formData?.buyer?.profile?.identityno,
							certno: formData?.buyer?.profile?.certno,
							certtype: formData?.buyer?.profile?.certtype,
							birthdate: formData?.buyer?.profile?.birthdate.replace(/\//g, "-"),
							gender: formData?.buyer?.profile?.gender,
							smsmobileno: regexFormater(formData?.buyer?.profile?.smsmobileno).removeSpace(),
							profiletype: 23,
							nationality: "",
							enfname: !formData?.buyer?.profile?.isLangPersian ? formData?.buyer?.profile?.fname : undefined,
							enlname: !formData?.buyer?.profile?.isLangPersian ? formData?.buyer?.profile?.lname : undefined,
							enfathername: !formData?.buyer?.profile?.isLangPersian ? formData?.buyer?.profile?.fathername : undefined,
							countryid: !formData?.buyer?.profile?.isLangPersian ? formData?.buyer?.profile?.countryid : undefined,
							documentid: resBuyerDocument.Result,
						};
						let responseProfile = await addProfile(payload);
						if (responseProfile) {
							payload = {
								profileid: responseProfile.profileId,
								addresstype: 0,
								addressmodel: {
									cityid: formData?.buyer?.profile?.cityid,
									mainstreet: formData?.buyer?.profile?.mainstreet,
									auxiliaryroad: formData?.buyer?.profile?.auxiliaryroad,
									alley: formData?.buyer?.profile?.alley,
									buildingno: formData?.buyer?.profile?.buildingno,
									floor: formData?.buyer?.profile?.floor,
									postalcode: formData?.buyer?.profile?.postalcode,
									tel: formData?.buyer?.profile?.tel,
									unit: formData?.buyer?.profile?.unit,
								},
							};

							let responseAddress = await addAddress(payload);
							if (responseAddress && !responseAddress.HasError) {
								payload.addresstype = 1;
								let resAgainAddress = await addAddress(payload);
								if (resAgainAddress && !resAgainAddress.HasError) {
									const buyerPhotoBase64 = await fileToBase64(values.documentBuyer);
								const sellerPhotoBase64 = await fileToBase64(values.documentSeller);
								dispatch(
										simcardPurchase({
											changeownership: {
												buyer: {
													profile: {
														...formData?.buyer?.profile,
														profileid: responseProfile.profileId,
														documentid: resBuyerDocument.Result,
														photo: buyerPhotoBase64,
													},
												},
												seller: {
													...formData.seller,
													documentid: resSellerDocument.Result,
													photo: sellerPhotoBase64,
												},
											},
										}),
									);
									nav(_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Prefactor);
								}
							}
						}
					}
				}
			}

			setIsLoading(false);
		} catch (error) {
			console.error(error);
			setIsLoading(false);
		}
	};
	const handleGetImageSeller = async (value) => {
		frmDocument.setFieldValue("documentSeller", value);
	};
	const handleGetImageBuyer = async (value) => {
		frmDocument.setFieldValue("documentBuyer", value);
	};
	return (
		<CWLayout>
			<div className="holder-top-of-page-content">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("changeOwnerShip.ownership.title") }]}
					/>
					<div className="title-page">
						<h3>{t("changeOwnerShip.ownership.title")}</h3>
						<p></p>
					</div>
				</div>
			</div>
			<div className="g-layout-content">
				<Content className="g-layout-main da-container">
					<div className="g-format-page">
						<div className="g-body-format-page">
							<div className="g-format-steps">
								<div className="holder-step">
									<Steps
										size="small"
										className="step-wizard"
										current={2}
										responsive
										items={[
											{
												title: "اطلاعات فروشنده",
											},
											{
												title: "اطلاعات خریدار",
											},
											{
												title: "آپلود مدرک شناسایی",
											},
											{
												title: "پیش فاکتور",
											},
											{
												title: "سند",
											},
										]}
									/>
								</div>
							</div>
							<div className="cw-swap-document">
								<Form id="frmDocument" form={frmDocument} onFinish={handleSubmit} layout="vertical">
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={12} xl={8}>
											<Form.Item
												className="input-normal"
												name="documentSeller"
												rules={[validateInput({ t: t, validate: true })]}
												label="تصویر مدرک شناسایی فروشنده ">
												<ResizeImage exportImage={handleGetImageSeller} />
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={12} xl={8}>
											<Form.Item
												className="input-normal"
												name="documentBuyer"
												rules={[validateInput({ t: t, validate: true })]}
												label="تصویر مدرک شناسایی خریدار  ">
												<ResizeImage exportImage={handleGetImageBuyer} />
											</Form.Item>
										</Col>
									</Row>
								</Form>
							</div>
						</div>
						<div className="g-footer-format-page">
							<div className="holder-button">
								<Button form="frmDocument" key="submit" htmlType="submit" className="btn-normal btn-aptel">
									ادامه
								</Button>
								<Button className="btn-normal">بازگشت</Button>
							</div>
						</div>
					</div>
				</Content>
			</div>
			<Loading isOpen={isLoading} text="لطفا چند لحظه منتظر بمانید" />
		</CWLayout>
	);
};

export default CWSwapDocument;
